@if (group && control) {
  <ng-container [formGroup]="group">
    @switch (getControlType()) {
      @case ('bool') {
        <label class="cipx-form-label">{{ getLabel() }}</label>
        <mat-button-toggle-group
          [formControlName]="question.question_code"
          [attr.aria-label]="getLabel()">
          <mat-button-toggle [value]="true">Yes</mat-button-toggle>
          <mat-button-toggle [value]="false">No</mat-button-toggle>
        </mat-button-toggle-group>
        @if (control.invalid && control.touched) {
          <mat-error>{{ getQuestionErrorText() }}</mat-error>
        }
      }
      @case ('radio') {
        <label class="cipx-form-label">{{ getLabel() }}</label>
        <mat-radio-group
          class="flex flex-row gap-4"
          [formControlName]="question.question_code"
          [attr.aria-label]="getLabel()">
          <mat-radio-button *ngFor="let opt of question.user_selected_options?.options" [value]="opt">
            {{ opt }}
          </mat-radio-button>
        </mat-radio-group>
        @if (control.invalid && control.touched) {
          <mat-error>{{ getQuestionErrorText() }}</mat-error>
        }
      }
      @case ('select') {
        <mat-form-field subscriptSizing="dynamic" hideRequiredMarker>
          <mat-label>{{ getLabel() }}</mat-label>
          <mat-select [formControlName]="question.question_code" [attr.aria-label]="getLabel()">
            @if (question.user_selected_options?.placeholder) {
              <mat-option [value]="null" disabled>{{ question.user_selected_options?.placeholder }}</mat-option>
            }
            <mat-option *ngFor="let opt of question.user_selected_options?.options" [value]="opt">
              {{ opt }}
            </mat-option>
          </mat-select>
          @if (question.question_help_text) {
            <mat-hint>{{ question.question_help_text }}</mat-hint>
          }
          @if (control.invalid) {
            <mat-error>{{ getQuestionErrorText() }}</mat-error>
          }
        </mat-form-field>
      }
      @case ('address') {
        <label class="cipx-form-label">{{ getLabel() }}</label>
        <sbd-app-address-form
          prefix=""
          customPrepend=""
          [formGroup]="addressGroup"
          [showCounty]="false"></sbd-app-address-form>
      }
      @case ('state') {
        <mat-form-field subscriptSizing="dynamic" hideRequiredMarker>
          <mat-label>{{ getLabel() }}</mat-label>
          <mat-select [formControlName]="question.question_code" [attr.aria-label]="getLabel()">
            <mat-option *ngFor="let state of states" [value]="state.value">
              {{ state.label }}
            </mat-option>
          </mat-select>
          @if (question.question_help_text) {
            <mat-hint>{{ question.question_help_text }}</mat-hint>
          }
          @if (control.invalid) {
            <mat-error>{{ getQuestionErrorText() }}</mat-error>
          }
        </mat-form-field>
      }
      @case ('date') {
        <mat-form-field subscriptSizing="dynamic" hideRequiredMarker>
          <mat-label>{{ getLabel() }}</mat-label>
          <input
            matInput
            type="date"
            [formControlName]="question.question_code"
            [placeholder]="question.question_placeholder" />
          @if (question.question_help_text) {
            <mat-hint>{{ question.question_help_text }}</mat-hint>
          }
          @if (control.invalid) {
            <mat-error>{{ getQuestionErrorText() }}</mat-error>
          }
        </mat-form-field>
      }
      @case ('number') {
        <mat-form-field subscriptSizing="dynamic" hideRequiredMarker>
          <mat-label>{{ getLabel() }}</mat-label>
          <input
            matInput
            type="number"
            [formControlName]="question.question_code"
            [placeholder]="question.question_placeholder" />
          @if (question.question_help_text) {
            <mat-hint>{{ question.question_help_text }}</mat-hint>
          }
          @if (control.invalid) {
            <mat-error>{{ getQuestionErrorText() }}</mat-error>
          }
        </mat-form-field>
      }
      @case ('textarea') {
        <mat-form-field subscriptSizing="dynamic" hideRequiredMarker>
          <mat-label>{{ getLabel() }}</mat-label>
          <textarea
            matInput
            rows="3"
            [formControlName]="question.question_code"
            [placeholder]="question.question_placeholder"></textarea>
          @if (question.question_help_text) {
            <mat-hint>{{ question.question_help_text }}</mat-hint>
          }
          @if (control.invalid) {
            <mat-error>{{ getQuestionErrorText() }}</mat-error>
          }
        </mat-form-field>
      }
      @default {
        <mat-form-field subscriptSizing="dynamic" hideRequiredMarker>
          <mat-label>{{ getLabel() }}</mat-label>
          <input
            matInput
            [formControlName]="question.question_code"
            [placeholder]="question.question_placeholder" />
          @if (question.question_help_text) {
            <mat-hint>{{ question.question_help_text }}</mat-hint>
          }
          @if (control.invalid) {
            <mat-error>{{ getQuestionErrorText() }}</mat-error>
          }
        </mat-form-field>
      }
    }
  </ng-container>
}
